// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-title{display:flex;align-items:center}.chip-wrapper{display:inline-block;line-height:30px;height:30px;width:30px;text-align:center;margin-bottom:10px;margin-right:0.5rem}.form-title-chip{margin-right:0.3rem;background-color:#f39b43;color:#fff;display:inline-block;line-height:30px;height:30px;width:30px;font-size:1.2rem;text-align:center}\n", ""]);
// Exports
module.exports = exports;
